import React from "react";
import {
  Add,
  DeleteOutline,
  ExpandMore,
  Payment,
} from "@mui/icons-material";

import "./MultiplePayment.css";

const PAYMENT_METHODS = [
  {
    value: "Cash",
    label: "Cash",
  },
  {
    value: "Credit",
    label: "Credit",
  },
  {
    value: "Debit",
    label: "Debit",
  },
  {
    value: "Account",
    label: "Account",
  },
  {
    value: "Cheque",
    label: "Cheque",
  },
  {
    value: "Gift",
    label: "Gift",
  },
 
];

const MultiplePayment = ({
  options = [],
  setOptions,
  paymentDescription = "",
  setPaymentDescription,
  paymentAccounts = [],
}) => {
  const updatePayment = (id, field, value) => {
    setOptions((currentOptions) =>
      currentOptions.map((payment) =>
        payment.id === id
          ? {
              ...payment,
              [field]: value,
            }
          : payment
      )
    );
  };

  const addPaymentRow = () => {
    const newPayment = {
      id: `payment-${Date.now()}-${Math.random()
        .toString(36)
        .substring(2, 8)}`,
      amount: "",
      method: "Cash",
      paymentAccount: "",
    };

    setOptions((currentOptions) => [...currentOptions, newPayment]);
  };

  const removePaymentRow = (id) => {
    setOptions((currentOptions) =>
      currentOptions.filter((payment) => payment.id !== id)
    );
  };

  const totalPayment = options.reduce(
    (total, payment) => total + (Number(payment.amount) || 0),
    0
  );

  const needsPaymentAccount = (method) => {
    return method === "Account";
  };

  return (
    <div className="multiple-payment">

      {/* Header */}
      <div className="multiple-payment__header">
        <div className="multiple-payment__title-wrapper">
          <Payment className="multiple-payment__title-icon" />

          <div>
            <h3 className="multiple-payment__title">
              Payment Options
            </h3>

            <span className="multiple-payment__subtitle">
              Add one or more payment methods
            </span>
          </div>
        </div>

        <div className="multiple-payment__summary">
          <span className="multiple-payment__summary-label">
            Total Payment
          </span>

          <strong className="multiple-payment__summary-value">
            {totalPayment.toFixed(2)}
          </strong>
        </div>
      </div>

      {/* Payment Rows */}
      <div className="multiple-payment__rows">

        {options.map((payment, index) => (
          <div
            className="multiple-payment__row"
            key={payment.id}
          >
            {/* Amount */}
            <div className="multiple-payment__field multiple-payment__amount">
              <label>
                Amount
              </label>

              <input
                type="number"
                min="0"
                step="0.01"
                value={payment.amount}
                placeholder="0.00"
                onChange={(event) =>
                  updatePayment(
                    payment.id,
                    "amount",
                    event.target.value
                  )
                }
              />
            </div>

            {/* Payment Method */}
            <div className="multiple-payment__field">
              <label>
                Payment Method
              </label>

              <div className="multiple-payment__select-wrapper">
                <select
                  value={payment.method}
                  onChange={(event) =>
                    updatePayment(
                      payment.id,
                      "method",
                      event.target.value
                    )
                  }
                >
                  {PAYMENT_METHODS.map((method) => (
                    <option
                      key={method.value}
                      value={method.value}
                    >
                      {method.label}
                    </option>
                  ))}
                </select>

                <ExpandMore />
              </div>
            </div>

            {/* Payment Account */}
            <div className="multiple-payment__field">
              <label>
                Payment Account
              </label>

              <div className="multiple-payment__select-wrapper">
                <select
                  value={payment.paymentAccount}
                  disabled={!needsPaymentAccount(payment.method)}
                  onChange={(event) =>
                    updatePayment(
                      payment.id,
                      "paymentAccount",
                      event.target.value
                    )
                  }
                >
                  <option value="">
                    {needsPaymentAccount(payment.method)
                      ? "Select account"
                      : "None"}
                  </option>

                  {paymentAccounts.map((account) => (
                    <option
                      key={account.id || account.value}
                      value={account.id || account.value}
                    >
                      {account.name || account.label}
                    </option>
                  ))}
                </select>

                <ExpandMore />
              </div>
            </div>

            {/* Delete */}
            <button
              type="button"
              className="multiple-payment__delete"
              onClick={() => removePaymentRow(payment.id)}
              title={`Remove payment ${index + 1}`}
            >
              <DeleteOutline />
            </button>
          </div>
        ))}

        {/* Empty State */}
        {options.length === 0 && (
          <div className="multiple-payment__empty">
            <Payment />

            <span>
              No payment option has been added yet.
            </span>
          </div>
        )}

      </div>

      {/* Add Payment */}
  <div className="fx-jb">
    <span>&nbsp;</span>
        <button
        type="button"
        className="multiple-payment__add-button"
        onClick={addPaymentRow}
      >
        <Add />
        Add Method
      </button>
  </div>

      {/* Payment Description */}
      <div className="multiple-payment__description">
        <label>
          Payment Description
        </label>

        <textarea
          value={paymentDescription}
          onChange={(event) =>
            setPaymentDescription(event.target.value)
          }
          placeholder="Payment description"
          rows={4}
        />
      </div>
    </div>
  );
};

export default MultiplePayment;